'use client';
import { useHasWebGameConsent } from '@/features/consent/shared/use-has-web-game-consent';
import { useOverlayStore } from '@/shared/components/overlay/overlay.store';
import Modal from '@/shared/components/overlay/modal';
import { useEffect } from 'react';
import { Button } from '@/shared/components/primitives/button';
import { useAppStore } from '@/features/shared/app-store';
import { useRouter } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import { pagesRoutes } from '@/shared/constants/routes';
import { TextNavLink } from '@/shared/components';
import { toggleCookieBanner } from '@ecom/storefront-consent/onetrust';

const CONSENT_MODAL_KEY = 'web-consent-overlay';

export const WebGameConsentCheck = () => {
  const t = useTranslations('GamePage.consentCheck');
  const showOverlay = useOverlayStore((state) => state.showOverlay);
  const hideOverlay = useOverlayStore((state) => state.hideOverlay);
  const hasWebGameConsent = useHasWebGameConsent();
  const consentFramework = useAppStore((s) => s.consent.framework);
  const router = useRouter();
  useEffect(() => {
    if (!hasWebGameConsent) {
      showOverlay(CONSENT_MODAL_KEY);
      return;
    }
    if (useOverlayStore.getState().activeModalKey === CONSENT_MODAL_KEY) {
      hideOverlay();
    }
  }, [hasWebGameConsent, hideOverlay, showOverlay]);

  const consentListTranslation =
    consentFramework === 'TCF' ? t.raw('consentList.TCF') : t.raw('consentList.Quebec');
  return (
    <Modal
      modalKey={CONSENT_MODAL_KEY}
      header={<h2 className='w-full text-center font-bold'>{t('title')}</h2>}
      closeable={false}
    >
      <div className='flex flex-col gap-2 px-12 py-8'>
        <p>{t('description')}</p>
        <ul className='ml-4 list-disc'>
          {consentListTranslation.map((title: string, index: number) => (
            <li key={index}>
              <p>{title}</p>
            </li>
          ))}
        </ul>
        <p className='mt-2'>
          {t.rich('moreInformation', {
            privacyPolicy: (chunks) => (
              <TextNavLink isUnderline prefetch={false} href={pagesRoutes.legal.privacyPolicy.href}>
                {chunks}
              </TextNavLink>
            ),
          })}
        </p>
        <div className='mt-8 flex flex-row items-center justify-center gap-4 max-sm:flex-col max-sm:items-center'>
          <Button className='min-w-52' variant='primary' onClick={() => router.back()}>
            {t('goBack')}
          </Button>
          {t('or')}
          <Button className='min-w-52' onClick={() => void toggleCookieBanner()}>
            {t('adjustCookieSettings')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
